"use client";

import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useHreflang } from "@/i18n/useHreflang";
import HeaderStrip from "./components/HeaderStrip";
import HeroSection from "./components/HeroSection";
import ScopeBanner from "./components/ScopeBanner";
import TermsSections from "./components/TermsSections";
import { injectMetaTags } from "@/lib/seoHelpers";

export default function TermsOfServicePage() {
  const { currentLang } = useLanguage();
  useHreflang();

  useEffect(() => {
    const isEs = currentLang === "es";
    document.title = isEs
      ? "T\u00E9rminos de Servicio \u2014 Windows and Doors Repair LLC Miami"
      : "Terms of Service \u2014 Windows and Doors Repair LLC Miami";

    const desc = isEs
      ? "T\u00E9rminos de servicio de Windows and Doors Repair LLC. Alcance del servicio, precios, garant\u00EDa de trabajo, responsabilidad, resoluci\u00F3n de disputas. Miami-Dade Florida."
      : "Windows and Doors Repair LLC terms of service. Service scope, pricing, workmanship guarantee, liability, dispute resolution. Miami-Dade Florida.";

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", desc);
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content = desc;
      document.head.appendChild(meta);
    }

    const cleanupSeo = injectMetaTags({
      title: isEs
        ? "T\u00E9rminos de Servicio \u2014 Windows and Doors Repair LLC Miami"
        : "Terms of Service \u2014 Windows and Doors Repair LLC Miami",
      description: desc,
      url: "https://impact-window-repair-miami.com/terms-of-service/",
      image: "https://impact-window-repair-miami.com/og/og-default.jpg",
      imageAlt: isEs
        ? "T\u00E9rminos de servicio Windows and Doors Repair LLC"
        : "Terms of service Windows and Doors Repair LLC",
      breadcrumbs: [
        { name: isEs ? "Inicio" : "Home", item: "https://impact-window-repair-miami.com/" },
        { name: isEs ? "T\u00E9rminos de Servicio" : "Terms of Service", item: "https://impact-window-repair-miami.com/terms-of-service/" }
      ],
      type: "website",
    });

    const schema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: isEs ? "T\u00E9rminos de Servicio" : "Terms of Service",
      description: desc,
      inLanguage: isEs ? "es-US" : "en-US",
      url: "https://impact-window-repair-miami.com/terms-of-service/",
      publisher: {
        "@type": "Organization",
        name: "Windows and Doors Repair LLC",
        telephone: "+17863774452",
        email: "contact@impact-window-repair-miami.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "848 Brickell Ave, PH-5",
          addressLocality: "Miami",
          addressRegion: "FL",
          postalCode: "33131",
          addressCountry: "US",
        },
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      cleanupSeo();
      document.head.removeChild(script);
    };
  }, [currentLang]);

  return (
    <main className="w-full">
      <HeaderStrip />
      <HeroSection />
      <ScopeBanner />
      <TermsSections />
    </main>
  );
}